/** health | motor — comma-separated in REACT_APP_ENABLED_CLAIM_CATEGORIES */
export const CLAIM_TYPE_CATEGORY = Object.freeze({
  HEALTH: "health",
  MOTOR: "motor",
});

export function getClaimTypeCategory(claim) {
  if (!claim) return null;
  const raw =
    claim.category_type ??
    claim.category ??
    claim.claim_category ??
    claim.type ??
    claim.type_category ??
    claim.claim_type_category;
  const normalized = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (normalized === CLAIM_TYPE_CATEGORY.MOTOR) return CLAIM_TYPE_CATEGORY.MOTOR;
  if (normalized === CLAIM_TYPE_CATEGORY.HEALTH) return CLAIM_TYPE_CATEGORY.HEALTH;
  return CLAIM_TYPE_CATEGORY.HEALTH;
}

export const getEnabledClaimCategories = () => {
  const raw = String(
    process.env.REACT_APP_ENABLED_CLAIM_CATEGORIES ?? "health,motor"
  )
    .replace(/['"]/g, "")
    .trim();
  const parsed = raw
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(
      (s) => s === CLAIM_TYPE_CATEGORY.HEALTH || s === CLAIM_TYPE_CATEGORY.MOTOR
    );
  return parsed.length > 0
    ? parsed
    : [CLAIM_TYPE_CATEGORY.HEALTH, CLAIM_TYPE_CATEGORY.MOTOR];
};

export const getClaimTypeCategoryOptions = () =>
  getEnabledClaimCategories().map((value) => ({
    label: value === CLAIM_TYPE_CATEGORY.MOTOR ? "Motor" : "Health",
    value,
  }));

export const isSingleClaimCategoryEnv = () =>
  getEnabledClaimCategories().length === 1;

export const shouldShowCaseCategoryPicker = () =>
  getEnabledClaimCategories().length > 1;

export const getDefaultClaimCategory = () => getEnabledClaimCategories()[0];

export const filterClaimTypesByEnabledCategories = (claimTypes = []) => {
  const enabled = getEnabledClaimCategories();
  return (claimTypes || []).filter((claim) =>
    enabled.includes(getClaimTypeCategory(claim))
  );
};

/** Motor form: category motor, or legacy claim type name "MOTOR OD". */
export const isMotorClaimType = (claim) => {
  if (!claim) return false;
  if (getClaimTypeCategory(claim) === CLAIM_TYPE_CATEGORY.MOTOR) return true;
  return claim?.name?.trim()?.toUpperCase() === "MOTOR OD";
};
